import { Directive, forwardRef } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { RegexConstants } from '../constants/regex.constants';

@Directive({
  selector: '[numberValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NumberValidatorDirective),
      multi: true,
    },
  ],
})
export class NumberValidatorDirective implements Validator {

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // Champ vide = valide (required est séparé si besoin)
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Vérifie si c'est un nombre entier ou décimal
    const isValid = RegexConstants.NUMBER_DECIMAL.test(value);

    return isValid ? null : { numberInvalid: true };
  }
}
